import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  checkMenu,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editInbound,
  fetchIdInbound,
  fetchListInspection,
  fetchVehicleOutboundWorkflow,
  selectIdInbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { PickingPage } from "./PickingPage";
import {
  fetchIdOutbound,
  selectIdOutbound,
  selectPermissionList,
  setPermisionBts,
  setPermisionHandover,
  setPermisionList,
  setPermisionPicking,
} from "./outboundSlice";
import { HandoverPage } from "./HandoverPage";
import { BackToStroragePage } from "./BackToStroragePage";
import {
  fetchMenuTab,
  selectMenuTab,
  selectLoadingMenu,
} from "../menu/menuSlice";
import { ErrorPermissionPage } from "../../utility/ErrorPermissionPage";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const WorkflowOutbound = (params) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdOutbound);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  const [paramFilter, setParamFilter] = useState("");
  const [paramValue, setParamValue] = useState("");

  // initial
  const dataParams = params.location.state;

  const dataMenuTab = useSelector(selectMenuTab);
  const loadingMenu = useSelector(selectLoadingMenu);
  const dataMenuList = useSelector(selectPermissionList);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      let result;

      if (dataParams === 0) {
        result = "6140,6210";
      } else if (dataParams === 1) {
        result = "6230,6310";
      } else if (dataParams === 2) {
        result = "6220,6320,6410";
      }

      await dispatch(
        fetchMenuTab({
          menu_url: "/outbound/job",
        })
      );

      await dispatch(fetchIdOutbound(id));
      setValue(dataParams);
      await dispatch(
        fetchVehicleOutboundWorkflow({
          outbound_id: id,
          vehicle_status: result,
          is_planned: "Y,N",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Picking") {
          return dispatch(setPermisionPicking(item.permissions));
        }
        if (item.menu_name === "Handover") {
          return dispatch(setPermisionHandover(item.permissions));
        }
        if (item.menu_name === "BTS") {
          return dispatch(setPermisionBts(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setValueTab(0);
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let result;

    if (value === 0) {
      result = "6140,6210";
    } else if (value === 1) {
      result = "6230,6310";
    } else if (value === 2) {
      result = "6220,6320,6410";
    }
    let params = {};
    params.outbound_id = id;
    params.vehicle_status = result;
    params.is_planned = "Y,N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleOutboundWorkflow(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const [valueTab, setValueTab] = useState(0);

  const [formPicking, setFormPicking] = useState({
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    from_location: {
      value: "",
      error: false,
      required: "N",
    },
    picking_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formHandover, setFormHandover] = useState({
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    handsover_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [formBTS, setFormBTS] = useState({
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    location: {
      value: "",
      error: false,
      required: "Y",
    },
    location_name: {
      value: "",
      error: false,
      required: "Y",
    },
    back_to_storage_date: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const [show, setShow] = useState(false);
  const [showScan, setShowScan] = useState(false);

  // formVehicle
  const [getData, setGetData] = useState(false);
  const [getDataHandover, setGetDataHandover] = useState(false);
  const [getDataBTS, setGetDataBTS] = useState(false);

  const [create, setCreate] = useState(false);

  // permison

  const [active, setActive] = useState("");
  const [list, setList] = useState([]);

  return loading || loadingMenu ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Activity Monitor
                </p>
              </div>
              <div className="d-flex justify-content-between mt-5 mb-5">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Outbound Job : {dataId.outbound_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest  text-white ml-5">
                  Workflow
                </div>
              </div>
              <>
                <Tabs
                  value={value}
                  onChange={handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  {checkMenu(dataMenuList, "Picking") ? (
                    <Tab label={`Picking : ${dataId.picking_status} >`} />
                  ) : (
                    <Tab
                      disabled
                      label={`Picking : You Dont Have Permission >`}
                    />
                  )}
                  {checkMenu(dataMenuList, "Handover") ? (
                    <Tab label={`Handover : ${dataId.handover_status} >`} />
                  ) : (
                    <Tab
                      disabled
                      label={`Handover : You Dont Have Permission >`}
                    />
                  )}
                  {checkMenu(dataMenuList, "Back To Storage") ? (
                    <Tab
                      label={`Back To Storage : ${dataId.back_to_storage_status} `}
                    />
                  ) : (
                    <Tab
                      disabled
                      label={`Back To Storage : You Dont Have Permission >`}
                    />
                  )}
                </Tabs>
                {value === 0 && (
                  <>
                    {checkMenu(dataMenuList, "Picking") ? (
                      <PickingPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formPicking}
                        setFormValues={setFormPicking}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        getData={getData}
                        setGetData={setGetData}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
                {value === 1 && (
                  <>
                    {checkMenu(dataMenuList, "Handover") ? (
                      <HandoverPage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formHandover}
                        setFormValues={setFormHandover}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        getData={getDataBTS}
                        setGetData={setGetDataBTS}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
                {value === 2 && (
                  <>
                    {checkMenu(dataMenuList, "Back To Storage") ? (
                      <BackToStroragePage
                        active={value}
                        paramFilter={paramFilter}
                        setParamFilter={setParamFilter}
                        paramValue={paramValue}
                        setParamValue={setParamValue}
                        value={valueTab}
                        setValue={setValueTab}
                        formValues={formBTS}
                        setFormValues={setFormBTS}
                        show={show}
                        setShow={setShow}
                        showScan={showScan}
                        setShowScan={setShowScan}
                        getData={getDataHandover}
                        setGetData={setGetDataHandover}
                        create={create}
                        setCreate={setCreate}
                      />
                    ) : (
                      <ErrorPermissionPage />
                    )}
                  </>
                )}
              </>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};
